import { render, staticRenderFns } from "./weekend2.vue?vue&type=template&id=2b28fa7c&"
import script from "./weekend2.vue?vue&type=script&lang=js&"
export * from "./weekend2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports